import { render, staticRenderFns } from "./cardLists.vue?vue&type=template&id=836234ec&scoped=true&"
import script from "./cardLists.vue?vue&type=script&lang=js&"
export * from "./cardLists.vue?vue&type=script&lang=js&"
import style0 from "./cardLists.vue?vue&type=style&index=0&id=836234ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "836234ec",
  null
  
)

export default component.exports